export default {
  backBtn: 'Retour',
  sendBtn: 'Envoyer',
  title: 'Synthèse & Médias',
  loading: 'Chargement...',
  unSelectAll: 'Tout désélectionner',
  selectAll: 'Tout sélectionner'
}
